export default {
    exception_detail_title: "Exception Details",
    exception_detail_all: "All",
    exception_detail_behavior: "Behavior",
    exception_detail_categories: "Categories",
    exception_detail_contacts: "Contacts",
    exception_detail_devices: "Devices",
    exception_detail_drivers: "Drivers",
    exception_detail_users: "Users",
    exception_detail_geofences: "Geofences",
    exception_detail_Maintenance: "maintenance",
    exception_detail_entity: "Entity",
    exception_detail_exception_detail: "Exception detail",
    exception_detail_no_data_available: "No Data Available",
    exception_detail_created_on: "Created On",
    exception_detail_message: "Message",
    exception_detail_search_by_message: "Search by Message",
}